<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,computed,watch } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import TextBox from "../../compositions/TextBox.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import ModalAppDialog from "../../compositions/ModalAppDialog.vue";
import PharmacyMedicineTagComponent from "../Common/PharmacyMedicineTagComponent.vue";
import config from "../../config.js";
import { errorAlertApp,confirmAlertApp } from "../../plugins/alert_app";
import { warningMark } from '../../plugins/medicine';
import { screenTransition,callBarcode,callSound } from "../../plugins/flutter";
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import moment from "moment";
import { useAppStockStore } from '../../stores/app_stock';

const appStock = useAppStockStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    user:{
      type:Object,
      required:true,
    },
    staffId:{
      type:Number,
      required:true,
    },
    medicines:{
      type:Array,
      required:true,
    },
    errorCode:{
      type:String,
      required:true,
    },
    viewMode:{
      type:Number,
      required:true,
    },
})

const isErrorDialog = ref(props.errorCode.length > 0 ? true : false);
const stockDeleteNumber = ref(0);
const onChangeStockDeleteNumber = (value) => {
  stockDeleteNumber.value = value;
}
const deleteReasons = reactive([]);
//全てはカットする
for (let i=0;i<config.STOCK_REASONS.length;i++) {
  if (config.STOCK_REASONS[i].id == -1) {
    continue;
  }
  deleteReasons.push(config.STOCK_REASONS[i]);
}
const stockDeleteReason = ref(0);
const onChangeStockDeleteReason = (value) => {
  stockDeleteReason.value = value;
}
const stockDeleteLotNo = ref('');
const onChangeStockDeleteLotNo = (value) => {
  stockDeleteLotNo.value = value;
}
const stockDeleteExpireDate = ref('');
const onChangeStockDeleteExpireDate = (value) => {
  stockDeleteExpireDate.value = value;
}
const closeErrorDialog = () => {
  isErrorDialog.value = false;
}
const isLoading = ref(false);
const stockNumber = ref(0);
const stockLotNo = ref('');
const onChangeStocLotNo = (value) => {
  stockLotNo.value = value;
}
const stockExpireDate = ref('');
const onChangeStockExpireDate = (value) => {
  stockExpireDate.value = value;
}
const viewMode = ref(props.viewMode);
const stockControlMedicine = reactive([]);
const updateStockControlConfirm = async () => {
  let result = await confirmAlertApp((appStock.stock_mode == config.STOCK_MODES['廃棄'] ? '廃棄' : '在庫') + 'を登録しますか？');
  if (result.isConfirmed) {
    await updateStockControl()
  }
}
const updateStockControl = async () => {
  let params = [];
  if (appStock.stock_mode == config.STOCK_MODES['廃棄']) {
    if (!stockDeleteNumber.value) {
      errorAlertApp('廃棄数を入力してください。');
      return;
    }
  } else {
    if (!stockNumber.value) {
      errorAlertApp('在庫数を入力してください。');
      return;
    }
  }
  if (appStock.stock_mode == config.STOCK_MODES['廃棄']) {
    params.push({
      medicine_id:stockControlMedicine[0].id,
      delete_number:Number(stockDeleteNumber.value),
      stock_reason:stockDeleteReason.value,
      lot_no:stockDeleteLotNo.value,
      expire_date:stockDeleteExpireDate.value,
    });
  } else {
    params.push({
      medicine_id:stockControlMedicine[0].id,
      stock_number:Number(stockNumber.value),
      lot_no:stockLotNo.value,
      expire_date:stockExpireDate.value,
      staff_id:props.staffId,
      update_stock_date:moment().format("YYYY-MM-DD HH:mm:ss")
    });
  }
  isLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update,{method:"post",data:params});
    if (response.data.status == 200) {
      //バーコード画面に遷移
      callBarcode(config.SPAPP_MENU['棚卸'])
    }
  } finally {
    isLoading.value = false;
  }
}
onMounted(() => {
  if (props.viewMode == 0) {
    if (isErrorDialog.value == true) {
      callSound(config.SPAPP_SOUND['エラー']);
    } else {
      if (props.medicines.length > 0) {
        stockControlMedicine.splice(0);
        stockControlMedicine.push(props.medicines[0]);
      }
      initSelectMedicine();
    }
  } else if (props.viewMode == 2) {
    showSelfInputDialog();
  }
});
const onChangeStockNumber = (value) => {
  stockNumber.value = value;
}
const callDeviceBarcode = () => {
  //バーコード呼び出し
  callBarcode(config.SPAPP_MENU['棚卸'])
}

//////////////////////////////////
// 手入力対応
const selectMedicine = reactive([]);
const selectOrgMedicineOptions = computed(() => {
  let result = [];
  return result;
});
const isSelfInputDialog = ref(false);
const isCheckLoading = ref(false);
const showSelfInputDialog = () => {
  isSelfInputDialog.value = true;
}
const closeSelfInputDialog = () => {
  isSelfInputDialog.value = false;
}
const onSelectChangeMedicine = (item) => {
  selectMedicine.splice(0);
  selectMedicine.push(item);
}
const selectSelfInputMedicine = () => {
  stockControlMedicine.splice(0);
  if (selectMedicine.length > 0) {
    stockControlMedicine.push(selectMedicine[0]);
  }
  closeSelfInputDialog();
}
// 手入力対応
//////////////////////////////////
////////////////////////////////
// 採用品選択画面
//　採用品が複数存在する場合は選択画面を出す
const isInitSelectMedicineDialog = ref(false);
const selectInitSelectMedicineId = ref(0);
const showInitSelectMedicineDialog = (medicineId) => {
  selectInitSelectMedicineId.value = medicineId;
  isInitSelectMedicineDialog.value = true;
}
const closeInitSelectMedicineDialog = () => {
  isInitSelectMedicineDialog.value = false;
}
const onInitSelectChangeMedicine = (medicineId) => {
  selectInitSelectMedicineId.value = medicineId;
}

const selectInitSelectMedicine = () => {
  stockControlMedicine.splice(0);
  for (let i=0;i<props.medicines.length;i++) {
    if (props.medicines[i].id == selectInitSelectMedicineId.value) {
      stockControlMedicine.push(props.medicines[i]);
      break;
    }
  }
  closeInitSelectMedicineDialog();
}
const initSelectMedicine = () => {
  if (props.medicines.length > 1) {
    showInitSelectMedicineDialog(props.medicines[0].id);
  }
}
//////////////////////////////////////
watch(stockControlMedicine,(newValue,oldValue) => {
  if (newValue.length > 0) {
    stockLotNo.value = newValue[0].lot_no;
    stockExpireDate.value = newValue[0].expire_date;
  }
},{deep:true});
</script>

<style scoped>
table td {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
.list {
  border: 1px solid #ccc;
}
table {
  width:100%;
  border-collapse:collapse;
}
table > tbody > tr {
  border-bottom:1px solid #ccc;
}
table > tbody > tr > td {
  padding:0.5em;
  border-right:1px solid #ccc;
}
.button {
  background-color:#F59E12;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
.submit-button {
  background-color: #1235F5;
  color: white;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
</style>
<template>
<div ref="element" class="relative">
  <div class="w-full p-2">
    <p class="text-lg mb-2">棚卸医薬品</p>
    <div class="overflow-y-auto list mb-2" style="height:75vh;">
      <table>
        <tbody>
          <tr v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full">
              <span v-html="(typeof medicine.product_detail_name !== 'undefined' ? medicine.product_detail_name + ' ' + warningMark(medicine) : '')"></span>
              <span v-if="medicine.is_deleted" class="text-red-500"><br>※削除済み採用品</span>
              <div v-if="medicine.tags !== 'undefined' && medicine.tags.length > 0">
                <pharmacy-medicine-tag-component
                  :tags="medicine.tags"
                  :apis="apis"
                  :pharmacy-medicine-id="0"
                  :is-edit="false"
                ></pharmacy-medicine-tag-component>
              </div>
            </td>
          </tr>
          <tr v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 bg-gray-400 text-white p-2">実在庫数</div>
              <div class="w-2/3 p-2">{{ medicine.real_stock_number }} {{ medicine.package_unit }}</div>
            </td>
          </tr>
          <tr v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 bg-gray-400 text-white p-2">仮在庫数</div>
              <div class="w-2/3 p-2">{{ medicine.stock_number }} {{ medicine.package_unit }}</div>
            </td>
          </tr>
          <tr v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 bg-gray-400 text-white p-2">棚番</div>
              <div class="w-2/3 p-2">{{ medicine.storage_bin }}</div>
            </td>
          </tr>
          <tr v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 bg-gray-400 text-white p-2">最終棚卸日時</div>
              <div class="w-2/3 p-2">{{ medicine.latest_inventory_date }}</div>
            </td>
          </tr>
          <tr v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/2 flex items-center px-4 border border-gray-200 rounded-sm dark:border-gray-700">
                  <input id="stock_mode_control" v-model="appStock.stock_mode" type="radio" :value="config.STOCK_MODES['棚卸']" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="stock_mode_control" class="w-full py-4 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">棚卸</label>
              </div>
              <div class="w-1/2 flex items-center px-4 border border-gray-200 rounded-sm dark:border-gray-700">
                  <input id="stock_mode_delete" v-model="appStock.stock_mode" type="radio" :value="config.STOCK_MODES['廃棄']" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="stock_mode_delete" class="w-full py-4 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">廃棄</label>
              </div>
            </td>
          </tr>
          <tr v-if="appStock.stock_mode == config.STOCK_MODES['棚卸']" v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">在庫数</div>
              <div class="w-2/3 p-2">
                <text-box
                  type="number"
                  font-size="1.125rem"
                  font-line-height="1.75rem"
                  :identity-id="String(medicine.id)"
                  :value="stockNumber"
                  :on-change="onChangeStockNumber"
                  :is-focus-clear="true"
                ></text-box>
              </div>
            </td>
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">ロット番号</div>
              <div class="w-2/3 p-2">
                <text-box
                  type="text"
                  font-size="1.125rem"
                  font-line-height="1.75rem"
                  :identity-id="String(medicine.id)"
                  :value="stockLotNo"
                  :on-change="onChangeStocLotNo"
                  :is-focus-clear="true"
                ></text-box>
              </div>
            </td>
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">有効期限</div>
              <div class="w-2/3 p-2">
                <text-box
                  type="date"
                  font-size="1.125rem"
                  font-line-height="1.75rem"
                  :identity-id="String(medicine.id)"
                  :value="stockExpireDate"
                  :on-change="onChangeStockExpireDate"
                ></text-box>
              </div>
            </td>
          </tr>
          <tr v-else v-for="medicine in stockControlMedicine" :key="medicine.id">
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">廃棄数</div>
              <div class="w-2/3 p-2">
                <text-box
                  type="number"
                  font-size="1.125rem"
                  font-line-height="1.75rem"
                  :identity-id="String(medicine.id)"
                  :value="stockDeleteNumber"
                  :on-change="onChangeStockDeleteNumber"
                  :is-focus-clear="true"
                ></text-box>
              </div>
            </td>
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">廃棄理由</div>
              <div class="w-2/3 p-2">
                <select-box
                  :value="stockDeleteReason"
                  :is-searchable="false"
                  :on-change="onChangeStockDeleteReason"
                  :options="deleteReasons"
                ></select-box>
              </div>
            </td>
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">ロット番号</div>
              <div class="w-2/3 p-2">
                <text-box
                  type="text"
                  font-size="1.125rem"
                  font-line-height="1.75rem"
                  :identity-id="String(medicine.id)"
                  :value="stockDeleteLotNo"
                  :on-change="onChangeStockDeleteLotNo"
                  :is-focus-clear="true"
                ></text-box>
              </div>
            </td>
            <td class="w-full flex flex-row items-center" style="padding:0;">
              <div class="w-1/3 p-2">有効期限</div>
              <div class="w-2/3 p-2">
                <text-box
                  type="date"
                  font-size="1.125rem"
                  font-line-height="1.75rem"
                  :identity-id="String(medicine.id)"
                  :value="stockDeleteExpireDate"
                  :on-change="onChangeStockDeleteExpireDate"
                ></text-box>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mb-4">
      <button type="button" @click="callDeviceBarcode()" class="button">バーコード読み込み</button>
    </div>
    <div class="mb-1">
      <button type="button" @click="updateStockControlConfirm()" class="submit-button">{{ appStock.stock_mode == config.STOCK_MODES['廃棄'] ? '廃棄' : '在庫' }}登録</button>
    </div>
  </div>
</div>
<modal-app-dialog
  :is-visible="isErrorDialog"
  :close="closeErrorDialog"
  cancel-button-name="閉じる"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-lg text-red-700">採用品に存在しません。({{ errorCode }})</div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isLoading"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-md">登録中です。しばらくお待ちください。</div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isSelfInputDialog"
  :close="closeSelfInputDialog"
  :submit="selectSelfInputMedicine"
  cancel-button-name="キャンセル"
  submit-button-name="棚卸する"
  :is-loading="isCheckLoading"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="m-1">
      <select-box
        :options="selectOrgMedicineOptions"
        :on-change-object="onSelectChangeMedicine"
        font-size="1.125rem"
        font-line-height="1.75rem"
        list-field-name="product_detail_name"
        list-field-name-option="relation_exists_message"
        list-id-name="id"
        list-height="20em"
        :value="0"
        :api-url="apis.medicine_list"
        place-holder="医薬品名を入力"
        :api-option-fields="{relation_pharmacy:1,is_except_relation:null,is_stock:1,is_latest_inventory_date:1}"
      ></select-box>
    </div>
    <table class="w-full">
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">タグ</th>
        <td class="block py-3 text-base md:table-cell md:w-2/3 md:px-3 md:py-2" v-for="medicine in selectMedicine" :key="medicine.id">
          <div v-if="typeof medicine.tags !== 'undefined' && medicine.tags.length > 0">
            <pharmacy-medicine-tag-component
              :tags="medicine.tags"
              :apis="apis"
              :pharmacy-medicine-id="0"
              :is-edit="false"
            ></pharmacy-medicine-tag-component>
          </div>
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">実在庫</th>
        <td class="block py-3 text-base md:table-cell md:w-2/3 md:px-3 md:py-2" v-for="medicine in selectMedicine" :key="medicine.id">
          {{ medicine.real_stock_number }} {{ medicine.package_unit }}
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">仮在庫</th>
        <td class="block py-3 text-base md:table-cell md:w-2/3 md:px-3 md:py-2" v-for="medicine in selectMedicine" :key="medicine.id">
          {{ medicine.stock_number }} {{ medicine.package_unit }}
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">棚番</th>
        <td class="block py-3 text-base md:table-cell md:w-2/3 md:px-3 md:py-2" v-for="medicine in selectMedicine" :key="medicine.id">
          {{ medicine.storage_bin }}
        </td>
      </tr>
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">最終棚卸日時</th>
        <td class="block py-3 text-base md:table-cell md:w-2/3 md:px-3 md:py-2" v-for="medicine in selectMedicine" :key="medicine.id">
          {{ medicine.latest_inventory_date }}
        </td>
      </tr>
    </table>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isInitSelectMedicineDialog"
  :close="closeInitSelectMedicineDialog"
  submit-button-name="選択する"
  :submit="selectInitSelectMedicine"
  cancel-button-name="閉じる"
>
  <template v-slot:default>
  <div class="mb-2">
    <select-box
      :options="medicines"
      :on-change="onInitSelectChangeMedicine"
      font-size="0.85rem"
      font-line-height="1.75rem"
      list-field-name="product_detail_name_reverse"
      list-id-name="id"
      list-height="10em"
      :is-searchable="false"
      :value="selectInitSelectMedicineId"
    ></select-box>
  </div>
  </template>
</modal-app-dialog>

</template>

